module.exports = __webpack_public_path__ + "img/thumb4.ca3295db.png";